import { h, defineComponent, VNode } from 'vue';
import { toUpperCaseExceptSpecialChars } from '@/ui/helpers';

export interface PageSubtitleProps {
  text: string;
  unsafe: boolean;
}

export const PageSubtitle = defineComponent({
  name: 'PageSubtitle',
  props: {
    text: {
      type: String,
      required: true,
    },
    unsafe: {
      type: Boolean,
      required: false,
      default: false,
    },
    isUpperCase: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    return function render(): VNode {
      return props.unsafe
        ? h('h2', {
          class: 'title is-5',
          domProps: { innerHTML: props.text },
        })
        : h('h2', {
          class: 'title is-5',
        }, [props.isUpperCase ? toUpperCaseExceptSpecialChars(props.text) : props.text]);
    };
  },
});

export function pageSubtitle(text: string, classes = '') {
  const props: PageSubtitleProps = {
    text,
    unsafe: false,
  };
  return h(PageSubtitle, {
    props,
    class: classes,
  });
}

export function pageSubtitleUnsafe(text: string, classes = '') {
  const props: PageSubtitleProps = {
    text,
    unsafe: true,
  };
  return h(PageSubtitle, {
    props,
    class: classes,
  });
}
